import Vue from 'vue';
import * as types from '../mutation-types';
import api from '@/services';
import router from '@/router';

export const userForgotPassword = async (context, email) => {
  const response = await api.User.forgotPassword(email);
  return response;
};

export const userResetPassword = async (
  context,
  { email, password, confirmPassword, resetPasswordToken }
) => {
  const response = await api.User.resetPassword(
    email,
    password,
    confirmPassword,
    resetPasswordToken
  );
  return response;
};

export const userValidateResetKey = async (context, key) => {
  const response = await api.User.validateResetKey(key);
  return response;
};

export const userLogin = async ({ dispatch }, userData) => {
  const response = await api.User.auth(userData.email, userData.password);

  const { token, user, config, gameState } = response;

  // TOKEN
  Vue.ls.set('token', token);
  api.User.setToken(token);

  // STOMP CONFIG
  Vue.ls.set('stompConfig', config);
  dispatch('setStompConfig', config);

  // ACTIVE GAME STATE
  if (gameState) {
    Vue.ls.set('gameState', gameState);
    dispatch('setGameState', gameState);
  }

  // USER DATA
  if (user) {
    Vue.ls.set('user', user);
    dispatch('setUserData', user);
    return user;
  }

  return false;
};

export const userRegister = async (
  { dispatch },
  { email, username, password, confirmPassword }
) => {
  const response = await api.User.register(
    email,
    username,
    password,
    confirmPassword
  );

  const { token, user } = response;

  if (token.length) {
    api.User.setToken(response.token);
    Vue.ls.set('token', response.token);

    if (user) {
      Vue.ls.set('user', user);
      dispatch('setUserData', user);
      return user;
    }
  }
  return false;
};

export const userLogout = ({ commit, getters }) => {
  Vue.ls.remove('user');
  Vue.ls.remove('token');
  Vue.ls.remove('stompConfig');
  Vue.ls.remove('gameState');

  commit(types.USER_REMOVE_DATA);

  // Redirect to login page
  if (router.currentRoute.name !== 'login') {
    router.push({ name: 'home' });
  }
};

export const updateProfileField = async (context, { field, data }) => {
  const response = await api.User.updateField(field, data);
  return response;
};

export const setUserData = ({ commit }, userData) => {
  commit(types.USER_SET_DATA, userData);
};

export const getUserData = async () => {
  const response = await api.User.getUser();
  return response;
};

export const updateUserData = async ({ dispatch }) => {
  const user = await dispatch('getUserData');
  dispatch('setUserData', user);
};

export const getGameState = async ({ commit }, gameId) => {
  const response = await api.User.getGameState(gameId);
  if (!gameId) commit(types.APP_SET_GAME_STATE, response);
  return response;
};

export const resetGameState = ({ commit }) => {
  commit(types.APP_RESET_GAME_STATE);
};
